const rowValidation = (state) => {
  const fields = ["bank", "amount", "date", "loanId", "utrNarration", "transactionId"];
  const numericFields = [
    { name: "amount", label: "Bulk Payment Amount" },
    { name: "loanId", label: "Loan ID" },
  ];
  fields.forEach((field) => {
    state[`${field}Class`] = "";
  });
  if (!state.bank) {
    appendErrorClass(state, "bank");
    return { message: "Please select Receiving Bank", error: true };
  }
  if (!state.amount) {
    appendErrorClass(state, "amount");
    return { message: "Please enter Bank Payment Amount", error: true };
  }
  if (+state.amount === 0) {
    appendErrorClass(state, "amount");
    return { message: "Bank Payment Amount cannot be zero", error: true };
  }
  if (!state.date) {
    appendErrorClass(state, "date");
    return { message: "Please select Payment Date", error: true };
  }

  const utrNarration = (state.utr_narration || "").trim();

  if (!utrNarration) {
    appendErrorClass(state, "utrNarration");
    return { message: "Please enter UTR/Narration", error: true };
  }

  const transactionId = (state.transaction_id || "").trim();

  if (!transactionId) {
    appendErrorClass(state, "transactionId");
    return { message: "Please enter Transaction ID", error: true };
  }

  let numericErrorFields = [];
  numericFields.forEach((field) => {
    if (field && isNaN(+state[field.name])) {
      appendErrorClass(state, field.name);
      numericErrorFields.push(field);
    }
  });

  if (numericErrorFields.length) {
    const filteredFields = numericErrorFields.filter(
      (field) => field.label !== "Loan ID"
    );
    if (filteredFields.length) {
      let msg = filteredFields.map((field) => field.label).join(", ");
      msg = filteredFields.length > 1 ? msg.slice(0) : msg;
      return { message: `${msg} should be numeric`, error: true };
    }
  }
  return { error: false };
};

const appendErrorClass = (state, fieldName) => {
  state[`${fieldName}Class`] = "errorInput";
};

export { rowValidation };
